import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { postFeedback } from "../../core/api/Api";
import { showToast } from "../../core/common-service/CommonService";
import useLangNavigate from "../common/useLangNavigate";
import "./Feedback.css";

const Feedback = () => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    name: "",
    email: "",
    phone: "",
    request: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    postFeedback({
      first_name: formData.firstName,
      last_name: formData.name,
      email: formData.email,
      phone: formData.phone,
      request: formData.request,
      message: formData.message,
    })
      .then((res) => {
        setLoading(false);
        if (res?.data?.success) {
          showToast({
            type: "success",
            message: t("feedback.success_message") || "Feedback submitted successfully!",
          });
          // Redirect to home page after a short delay
          setTimeout(() => {
            navigate("/home");
          }, 1500);
        }
      })
      .catch((err) => {
        setLoading(false);
        showToast({
          type: "error",
          message: t("error.error_in_your_request"),
        });
      });
  };

  return (
    <section className="aai-feedback-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 mb-5 mb-lg-0">
            <div className="aai-feedback-text">
              <h1 className="aai-feedback-title mb-4">{t("feedback.title")}</h1>
              <p className="aai-feedback-description">
                {t("feedback.description")}
              </p>
              <p className="aai-feedback-spam-note">
                {t("feedback.spam_note")}
              </p>
              <p className="aai-feedback-contact">
                {t("feedback.contact_fallback")}
              </p>
            </div>
          </div>
          <div className="col-lg-7">
            <form onSubmit={handleSubmit} className="aai-feedback-form">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    name="firstName"
                    className="form-control aai-feedback-input"
                    placeholder={t("feedback.first_name")}
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    name="name"
                    className="form-control aai-feedback-input"
                    placeholder={t("feedback.last_name")}
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="email"
                    name="email"
                    className="form-control aai-feedback-input"
                    placeholder={t("feedback.email")}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="tel"
                    name="phone"
                    className="form-control aai-feedback-input"
                    placeholder={t("feedback.phone")}
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <input
                    type="text"
                    name="request"
                    className="form-control aai-feedback-input"
                    placeholder={t("feedback.your_request")}
                    value={formData.request}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <textarea
                    name="message"
                    className="form-control aai-feedback-textarea"
                    placeholder={t("feedback.message")}
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-end">
                  <button type="submit" className="aai-feedback-submit-btn" disabled={loading}>
                    {loading ? t("feedback.sending") || "Sending..." : t("feedback.send")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feedback;
